import {
  UPDATE_THRIV_AUTH,
  UPDATE_VERIFY_DOB,
  initialThrivAuthState,
} from './constants'

export const thrivAuthReducer = (
  state: ThrivAuthState = initialThrivAuthState,
  // Type any is intentional here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: ReducerActions<any>
): ThrivAuthState => {
  const { type: actionType, payload: actionPayload } = action

  switch (actionType) {
    case UPDATE_THRIV_AUTH:
      return {
        ...state,
        ...actionPayload,
      }
    case UPDATE_VERIFY_DOB:
      return {
        ...state,
        showVerifyDOBPopup: actionPayload,
      }
    default:
      return state
  }
}
